import { 
  collection, 
  addDoc, 
  doc, 
  updateDoc, 
  getDoc,
  Timestamp 
} from 'firebase/firestore';
import { db } from '../config/firebase';
import { Payment, CreatePaymentData } from '../types/payment.types';

/**
 * Crea un registro de pago pendiente
 */
export const createPayment = async (data: CreatePaymentData): Promise<string> => {
  try {
    const paymentData = {
      eventId: data.eventId,
      userId: data.userId,
      amount: data.amount,
      currency: data.currency,
      paypalLink: data.paypalLink,
      status: 0, // ← 0 = pending
      createdAt: Timestamp.now(),
      verifiedAt: null,
      verifiedBy: null,
      paypalTransactionId: null
    };

    const docRef = await addDoc(collection(db, 'payments'), paymentData);
    console.log('✅ Payment record created:', docRef.id);
    return docRef.id;
  } catch (error) {
    console.error('❌ Error creating payment:', error);
    throw error;
  }
};

/**
 * Obtiene un pago por ID
 */
export const getPayment = async (paymentId: string): Promise<Payment | null> => {
  try {
    const docRef = doc(db, 'payments', paymentId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return {
        id: docSnap.id,
        ...docSnap.data(),
        createdAt: docSnap.data().createdAt?.toDate(),
        verifiedAt: docSnap.data().verifiedAt?.toDate()
      } as Payment;
    }

    return null;
  } catch (error) {
    console.error('❌ Error getting payment:', error);
    throw error;
  }
};

/**
 * Verifica un pago manualmente (admin)
 * Actualiza payment status a 1 (verified)
 */
export const verifyPayment = async (
  paymentId: string, 
  transactionId: string,
  verifiedBy: string
): Promise<void> => {
  try {
    const paymentRef = doc(db, 'payments', paymentId);
    await updateDoc(paymentRef, {
      status: 1, // ← 1 = verified
      verifiedAt: Timestamp.now(),
      verifiedBy: verifiedBy,
      paypalTransactionId: transactionId
    });
    console.log('✅ Payment verified:', paymentId);
  } catch (error) {
    console.error('❌ Error verifying payment:', error);
    throw error;
  }
};

/**
 * Marca un pago como fallido (admin)
 * Actualiza payment status a 2 (failed)
 */
export const failPayment = async (paymentId: string): Promise<void> => {
  try {
    const paymentRef = doc(db, 'payments', paymentId);
    await updateDoc(paymentRef, {
      status: 2 // ← 2 = failed
    });
    console.log('⚠️ Payment marked as failed:', paymentId);
  } catch (error) {
    console.error('❌ Error failing payment:', error);
    throw error;
  }
};